<template>
    <div class="horizontal-menu-wrapper diy_nav_bar" style="display:block;">
        <div class="header-navbar navbar-expand-sm navbar navbar-horizontal navbar-light navbar-shadow menu-border d-none d-xl-block floating-nav" style="display:none !important" v-if="(userStore.user.isTeamMember == true)">
        </div>
        
        <div class="header-navbar navbar-expand-sm navbar navbar-horizontal navbar-light navbar-shadow menu-border d-none d-xl-block floating-nav" style="display:block" v-else-if="shouldShowSection == true">
            <!-- <div class="navbar-container main-menu-content" style="height: 0px;"> -->
            <ul id="main-menu-navigation" class="nav navbar-nav">
                <!-- slot left section of the header added to slot -->
                <slot name="left_slot"></slot>
                <!-- end of left section -->
            </ul>
        </div>
        
        <!-- show side bar -->
        <div class="main-menu menu-fixed menu-accordion menu-shadow d-block d-xl-none expanded menu-light diy_sidebar_menu" style="overflow:auto">
            <div class="navbar-header expanded">
                <ul class="nav navbar-nav flex-row">
                    <li class="nav-item mr-auto">
                        <a class="navbar-brand" :href="getRoute('landing-page')">
                            <span class="brand-logo">
                                <img :src="settingStore.favicon" alt="">
                            </span>
                            <h2 class="brand-text">Creditfixrr</h2>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="shadow-bottom"></div>
            <div class="main-menu-content ps--active-y diy_nav">
                <ul class="navigation navigation-main">
                    <!-- slot left section of the header added to slot -->
                    <slot name="right_slot"></slot>
                    <!-- end of left section -->
                </ul>
                <div class="ps__rail-x" style="left: 0px; bottom: 0px;">
                    <div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px;"></div>
                </div>
                <div class="ps__rail-y" style="top: 0px; right: 0px;">
                    <div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 0px;"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref } from 'vue'
import { useUserStore } from '../../../../stores/UserStore.js'
import { useSettingStore } from '../../../../stores/SettingStore.js'
import { getRoute } from '../../../../utilities/_helpers'
import {useRoute} from 'vue-router'
export default{
    components:{

    },
    setup(props){
        return{
            userStore:useUserStore(),
            settingStore: useSettingStore(),
            getRoute: getRoute,
        }
    },
    computed:{
        shouldShowSection() {
            const route = useRoute();
            const hiddenRoutes = ['dispute-letter', 'dispute-report','disputes-report'];
            return !hiddenRoutes.includes(route.name);
        },
    },
    
    created(){
    },
    update(){
        console.log(this.$route)
    },
    mounted(){
        
    },
    methods:{
    },
}
</script>
<style>
.diy_nav_bar .header-navbar.floating-nav {
    position: fixed;
    right: 0;
    margin: 5rem 2rem 0 !important;
    width: calc(100vw - (100vw - 100%) - calc(2rem * 2) - 0px) !important;
    border-radius: 0.428rem;
    z-index: 12;
}
.diy_nav_bar .navbar-floating .navbar-container {
    padding: 0.8rem 1rem;
}
.diy_nav_bar.horizontal-menu-wrapper .header-navbar .navbar-container {
    padding: 0 1rem;
    width: 100%;
    height: 0px !important;
}
.diy_nav_bar.horizontal-menu-wrapper .header-navbar.navbar-horizontal ul#main-menu-navigation>li {
    padding-top: 0.857rem;
    padding-bottom: 0.857rem;
}
.diy_nav_bar .header-navbar .navbar-container ul.navbar-nav li {
    line-height: 1.5;
}
.diy_nav_bar.horizontal-menu-wrapper .header-navbar.navbar-horizontal ul#main-menu-navigation>li.active>a {
    background: #4b9a5e !important;
}
.diy_nav_bar.horizontal-menu-wrapper .header-navbar.navbar-horizontal ul#main-menu-navigation>li.active>a {
    -webkit-box-shadow: 0 0 6px 1px #4b9a5e !important;
    box-shadow: 0 0 6px 1px #4b9a5e !important;
    border-radius: 4px;
}
.diy_nav_bar.horizontal-menu-wrapper .header-navbar.navbar-horizontal ul#main-menu-navigation>li.active>a {
    -webkit-box-shadow: 0 0 6px 1px #4b9a5e !important;
    color: #fff;
}
.diy_nav_bar.horizontal-menu-wrapper .header-navbar.navbar-horizontal ul#main-menu-navigation>li>a {
    padding: 0.715rem 1.25rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.diy_nav_bar .header-navbar .navbar-container ul.navbar-nav li>a.nav-link {
    padding: 0 0.5rem;
}
.diy_nav_bar .header-navbar .navbar-container ul.navbar-nav li>a.nav-link {
    padding: 0 0.5rem;
}
.diy_nav_bar .header-navbar .navbar-container ul.navbar-nav li>a.nav-link {
    color: #6e6b7b;
    position: relative;
}
.diy_nav_bar.horizontal-menu-wrapper .header-navbar.navbar-horizontal ul#main-menu-navigation>li>a {
    margin-right: 0.715rem;
}
.diy_nav_bar.horizontal-menu-wrapper .header-navbar.navbar-horizontal ul#main-menu-navigation>li>a {
    padding: 0.715rem 1.25rem;
}
.diy_nav_bar.horizontal-menu-wrapper .header-navbar.navbar-horizontal .dropdown-menu {
    border: none;
    margin-top: 0;
}
.diy_nav_bar.horizontal-menu-wrapper .header-navbar.navbar-horizontal .dropdown-menu {
    min-width: 215px;
    min-height: 52px;
}
@media (min-width: 576px){
    .diy_nav_bar .navbar-expand-sm .navbar-nav .dropdown-menu {
        position: absolute;
    }
}
.diy_nav_bar .navbar-nav .dropdown-menu {
    float: none;
}
.diy_nav_bar .dropdown:hover .dropdown-menu{
    display:block;
}
.diy_nav_bar .vertical-layout .header-navbar .navbar-container ul.navbar-nav li.dropdown .dropdown-menu {
    top: 48px !important;
}

::-webkit-scrollbar {
    width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #555;
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
}
.ps-container.main-menu-content.scroll-area.ps.diy_nav:hover {
    overflow-y: auto !important;
}
.diy_sidebar_menu .navigation li a svg{
    height: 20px;
    width: 20px;
    /* font-size: 11px; */
    margin-right: 1.38rem;
}
</style>
